'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CircledCheckIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CircledCheckIcon">
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4986_14558)">
          <path
            d="M9.40997 0C7.54885 0 5.72953 0.551885 4.18207 1.58587C2.63461 2.61985 1.42851 4.08948 0.716295 5.80893C0.00407721 7.52837 -0.182272 9.4204 0.180814 11.2458C0.5439 13.0711 1.44011 14.7478 2.75612 16.0638C4.07213 17.3798 5.74882 18.276 7.57418 18.6391C9.39953 19.0022 11.2916 18.8159 13.011 18.1036C14.7305 17.3914 16.2001 16.1853 17.2341 14.6379C18.2681 13.0904 18.8199 11.2711 18.8199 9.40997C18.8199 6.91429 17.8285 4.52083 16.0638 2.75612C14.2991 0.991404 11.9056 0 9.40997 0ZM14.8442 6.43014L9.4727 13.715C9.4102 13.8002 9.33113 13.8719 9.24023 13.9257C9.14934 13.9796 9.0485 14.0145 8.94377 14.0284C8.83904 14.0424 8.73258 14.035 8.63077 14.0067C8.52897 13.9785 8.43393 13.9299 8.35135 13.864L4.51679 10.7979C4.43623 10.7332 4.36926 10.6532 4.31972 10.5626C4.27018 10.4719 4.23906 10.3723 4.22812 10.2696C4.21719 10.1668 4.22668 10.0629 4.25603 9.96384C4.28538 9.86477 4.33403 9.77248 4.39916 9.69226C4.52947 9.53415 4.71648 9.43331 4.92019 9.41132C5.12389 9.38934 5.32812 9.44796 5.48915 9.57464L8.68854 12.131L13.5817 5.48915C13.7052 5.3238 13.8889 5.21379 14.0929 5.18296C14.2969 5.15214 14.5049 5.20298 14.6717 5.32447C14.7564 5.38513 14.8282 5.46206 14.8828 5.55077C14.9374 5.63948 14.9739 5.73818 14.9899 5.84112C15.006 5.94405 15.0014 6.04916 14.9764 6.15029C14.9513 6.25143 14.9064 6.34656 14.8442 6.43014Z"
            fill={sx?.color || '#377F86'}
          />
        </g>
        <defs>
          <clipPath id="clip0_4986_14558">
            <rect width="18.8199" height="18.8199" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

CircledCheckIcon.propTypes = {
  sx: PropTypes.object
}
